const currentYear = new Date().getFullYear();

export const text = {
  copyright: `© ${currentYear} TraStar Inc. All Rights Reserved`,
  privacy: "Privacy Policy",
  terms: "Terms of Service",
};
